<template>
  <v-app :dark="darkMode" id="inspire">
    <router-view ></router-view>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "NoLayout",
    computed: {
      ...mapGetters("app", {
        darkMode: "darkMode"
      }),
    }
}

</script>